import axios from 'axios';

const ItemApi = {};

const nonce = devsAccountingApi.nonce;

ItemApi.index = async (params = {}) => {
    const url = '/wp-json/devs-accounting/v1/items/';
    try {
        const response = await axios.get(url, { params: params });
        return {
            data: response.data.data || [], // Items list
            total_items: response.data.total_items || 0, // Total items count
            total_pages: response.data.total_pages || 1, // Total number of pages
            current_page: response.data.current_page || 1, // Current page number
        };
    } catch (error) {
        console.error('Error fetching items:', error);
        return {
            data: [],
            total_items: 0,
            total_pages: 0,
            current_page: 1,
        };
    }
};


ItemApi.show = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/show-item/' + id;
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

ItemApi.delete = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/delete-item/' + id;
    try {
        const response = await axios.get(url, {
            headers: {
                'X-WP-Nonce': nonce
            }
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

ItemApi.save = async (data) => {
    let url = "/wp-json/devs-accounting/v1/add-item/";
    const res = await axios.post(url, data, {
        headers: {
            'X-WP-Nonce': nonce
        }
    }).then(response => {
        return response.data;
    }).catch(error => { return error.response.data; });
    return res;
}

ItemApi.inventory = async (data) => {
    let url = "/wp-json/devs-accounting/v1/update-item-inventory/";
    const res = await axios.post(url, data, {
        headers: {
            'X-WP-Nonce': nonce
        }
    }).then(response => {
        return response.data;
    }).catch(error => { return error.response.data; });
    return res;
}


export default ItemApi;
